import ProposalCenter from '@/components/proposals/legacy/ProposalCenter';

// View-health markers for this route are fired from deeper components that
// actually hold the data/render state:
//   - ProposalCenter fires `actions-list-ready` / `actions-list-empty-ready`
//     (owns the list query) and `proposal-detail-ready` (owns the detail
//     query).
//   - ProposalListPanel fires `actions-list-items-rendered` (post-commit of
//     its own render).
//   - ProposalDetailPanel fires `proposal-actions-rendered` (post-commit of
//     the detail/action render).
// See route config at `dashboard.routes.tsx` → `actions/*`.
export default function ActionsPage() {
  return (
    <div className='flex flex-col h-full min-h-0 overflow-hidden'>
      <div className='flex-1 min-h-0 overflow-hidden'>
        <ProposalCenter />
      </div>
    </div>
  );
}
